import { Tooltip } from '@mui/material';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface TooltipIconProps {
  labelId?: string;
  defaultLabel?: string;
  label?: string;
  children: JSX.Element;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const ActionToolTip: FC<TooltipIconProps> = ({
  labelId,
  defaultLabel,
  label,
  children,
  placement = 'bottom',
}) => {
  const iconTitle = useIntl();
  const tooltipTitle =
    label ??
    iconTitle.formatMessage({
      id: labelId,
      defaultMessage: defaultLabel,
    });

  return (
    <Tooltip title={tooltipTitle} arrow followCursor placement={placement}>
      {children}
    </Tooltip>
  );
};

export default ActionToolTip;
